import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Grid} from "@mui/material";
import {AntSwitchSeeker, ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core";

import {useUserApp} from "@hooks";
import {MatchersFinishPage, MatchersNumItems} from "../@components";
import {useMatchersSKUsTarget} from "./@hooks";
import MatchersSKUsOptions from "./Options";
import MatcherSkusTarget from "./Target";
import {isLoadMoreItems, matcherSKUDrawerData} from "./@signals";
import {useProxiedImage} from "../@hooks";


export default function MatchersSKUsContent() {
	const { isAdmin } = useUserApp()
	const showOptions = useSignal(true)

	const {
		targetIndex, targetData, selectedSKU, setSelectedSKU, setTargetIndex, finishItems, saveMapping, needMorItems, callNeedSku, handleMoreProducts,
		isLoadingMapping
	} = useMatchersSKUsTarget()

	if (finishItems)
		return <MatchersFinishPage onClick={handleMoreProducts} />

	const { decodedURL: __thumbnail } = useProxiedImage(targetData.thumbnail)

	return <Grid container spacing={2}>
		<Grid item xs={12} display="flex" justifyContent="space-between">
			<Box display="flex">
				<MatchersNumItems
					version="skus"
					isLoadedMoreItems={isLoadMoreItems.value}
				/>
			</Box>

			<Box display="flex" justifyContent="flex-end" gap={2}>
				<AntSwitchSeeker
					trueText="Show"
					falseText="Hide IA Candidate "
					checked={showOptions.value}
					onChange={e => showOptions.value = e.target.checked}
				/>

				{ !isAdmin && <ButtonLoadingSeeker
					color="error"
					loading={isLoadingMapping}
					disabled={needMorItems}
					startIcon={<IconSeeker icon="person-circle-question" />}
					onClick={callNeedSku}
				>
					Not Found
				</ButtonLoadingSeeker> }

				{ !!isAdmin && <ButtonLoadingSeeker
					color="info"
					loading={isLoadingMapping}
					disabled={needMorItems}
					startIcon={<IconSeeker icon="plus" />}
					onClick={() => {
						matcherSKUDrawerData.value = {
							...targetData,
							categoryID: null
						}
					}}
				>
					Create SKU
				</ButtonLoadingSeeker> }

				{ !!isAdmin && <ButtonLoadingSeeker
					color="warning"
					loading={isLoadingMapping}
					disabled={needMorItems}
					startIcon={<IconSeeker icon="cart-plus" />}
					onClick={() => saveMapping(true)}
				>
					Skip
				</ButtonLoadingSeeker> }

				<ButtonLoadingSeeker
					color="success"
					loading={isLoadingMapping}
					startIcon={<IconSeeker icon="badge-check" />}
					disabled={selectedSKU === null || needMorItems}
					onClick={() => saveMapping()}
				>
					Validate
				</ButtonLoadingSeeker>
			</Box>
		</Grid>

		<Grid item xs={7} xl={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: "75vh" }}>
			<MatcherSkusTarget
				targetIndex={targetIndex}
				data={targetData}
				thumbnail={__thumbnail}
				handleChangeIndex={setTargetIndex}
				isLoadingMapping={isLoadingMapping}
			/>
		</Grid>

		<Grid item xs={5} xl={6}>
			<MatchersSKUsOptions
				showOptions={showOptions.value}
				targetIndex={targetIndex}
				targetImage={__thumbnail}
				brandID={targetData.brandID}
				options={targetData.AIOptions || []}
				selected={selectedSKU}
				setSelectedSKU={setSelectedSKU}
				saveMapping={saveMapping}
			/>
		</Grid>
	</Grid>
}